import Vue from "vue";
import { isMobile } from "@/constants/breakpoints";

/** SCSS `@include mq("sp")`（767px 以下）と揃える */
export default Vue.extend({
  data() {
    return {
      isSpScreen: isMobile(),
    };
  },
  mounted() {
    window.addEventListener("resize", this.syncSpScreen);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.syncSpScreen);
  },
  methods: {
    syncSpScreen() {
      this.isSpScreen = isMobile();
    },
  },
});
